import { connect } from 'react-redux';
import Dashboard from './dashboard';

export default connect()(Dashboard);
